export default __webpack_public_path__ + "static/media/font.ed6fa3de.woff";